export default __webpack_public_path__ + "static/media/1872.d1cd764a.png";